module.exports = __webpack_public_path__ + "img/home_lottery_type2.40be0d2c.png";